import { render, staticRenderFns } from "./exchangesettings.vue?vue&type=template&id=ff4ae182&scoped=true"
import script from "./exchangesettings.vue?vue&type=script&lang=js"
export * from "./exchangesettings.vue?vue&type=script&lang=js"
import style0 from "./exchangesettings.vue?vue&type=style&index=0&id=ff4ae182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4ae182",
  null
  
)

export default component.exports